import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { RecipeService } from '../../services/recipe.service';

@Component({
  selector: 'app-recipe-list',
  standalone: true,
  imports: [CommonModule, FormsModule, TableModule, RouterModule, PaginatorModule],
  templateUrl: './recipe-management.component.html',
  styleUrls: ['./recipe-management.component.css']
})
export class RecipesComponent implements OnInit {
  pageTitle = 'All Recipes';
  pageNumber: any;
  totalRecords: any;
  firstPage: number = 0;
  rowNumber: number = 0;

  receipes: any[] = [];         // Displayed list
  allRecipes: any[] = [];       // Full unfiltered list for client-side search
  searchfield: any;
  timeout: any = null;

  constructor(private receipeService: RecipeService) {}

  ngOnInit(): void {
    this.receipeService.reciepes(1).subscribe((response: any) => {
      this.handleListing(response);
    });
  }

// recipe-management.component.ts
// In recipe-management.component.ts

searchRecipe(event: any) {
  clearTimeout(this.timeout);
  const value = event.target.value?.trim() || '';
  console.log('Searching for:', value); // Debug log

  this.timeout = setTimeout(() => {
    if (value) {
      this.receipeService.searchRecipes(value).subscribe({
        next: (response) => {
          console.log('Search response:', response); // Debug log
          if (!response?.recipes?.length) {
            console.warn('No recipes found for:', value);
            this.receipes = []; // Clear results
          } else {
            this.handleListing(response);
          }
        },
        error: (err) => {
          console.error('Search error:', err);
          this.receipes = []; // Clear results on error
        }
      });
    } else {
      // Reset to default list
      this.receipeService.reciepes(1).subscribe((response: any) => {
        this.handleListing(response);
      });
    }
  }, 300);
}

handleListing(response: any) {
  try {
    console.log('Raw response:', response);
    
    let recipesArray = response?.data || response?.recipes || [];
    
    if (!Array.isArray(recipesArray)) {
      console.warn('Invalid recipes format:', recipesArray);
      recipesArray = [];
    }

    this.totalRecords = response?.totalRecords || response?.count || recipesArray.length;

    this.allRecipes = [...recipesArray];
    this.receipes = [...this.allRecipes];
    console.log('Processed recipes:', this.receipes);
    
  } catch (e) {
    console.error('Error processing response:', e);
    this.receipes = [];
    this.allRecipes = [];
  }
}
// Update your getNextPage method
getNextPage(event: any) {
  const pageNumber = event.page + 1;
  this.rowNumber = event.first;
  
  if (!this.searchfield) {
    this.receipeService.reciepes(pageNumber)
      .subscribe((response: any) => this.handleListing(response));
  } else {
    this.receipeService.searchRecipes(
      this.searchfield, 
      '', '', '0', '99999', 
      pageNumber
    ).subscribe((response: any) => this.handleListing(response));
  }
}


  private executeListing(value: string) {
  this.receipeService.searchRecipes(value).subscribe((response: any) => {  
    this.handleListing(response);
  });
}
}
